// src/App.tsx
import React from 'react';
import Chat from './components/Chat';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Chat/>}/>
      </Routes>
    </Router>
  );
};

export default App;